export class SosInverso {
  idProposta: string;
  idMotivoSos: number;
  observacaoSos: string;
}
